export enum EColorName {
  PRIMARY = 'primary'
}

export const themeColors = [EColorName.PRIMARY]
